module.exports = "../images/fishing-lodge-16.jpg?v=e53316c";